// Shared brand data — single source of truth for both apps. Generated/maintained;
// edit here, not the per-app overlays. APP_BUNDLES carries exam_name/exam_code (mobile
// reads them; web ignores). See docs/app-constant-usage-audit.md.
export const APP_BUNDLES = [
    {
        title: 'SIE',
        key: 'sie',
        description: 'Securities Industry Essentials',
        exam_name: 'SIE',
        exam_code: '',
        bundle_firebase_collection_name: 'SIE',
    },
    {
        title: 'Series 6',
        key: 'series6',
        description: 'Investment Company and Variable Contracts Products Representative',
        exam_name: 'Series 6',
        exam_code: '',
        bundle_firebase_collection_name: 'SERIES6',
    },
    {
        title: 'Series 7',
        key: 'series7',
        description: 'General Securities Representative',
        exam_name: 'Series 7',
        exam_code: '',
        bundle_firebase_collection_name: 'SERIES7',
    },
    {
        title: 'Series 63',
        key: 'series63',
        description: 'Uniform Securities Agent State Law',
        exam_name: 'Series 63',
        exam_code: '',
        bundle_firebase_collection_name: 'SERIES63',
    },
    {
        title: 'Series 65',
        key: 'series65',
        description: 'Uniform Investment Adviser Law',
        exam_name: 'Series 65',
        exam_code: '',
        bundle_firebase_collection_name: 'SERIES65',
    },
    {
        title: 'Series 66',
        key: 'series66',
        description: 'Uniform Combined State Law',
        exam_name: 'Series 66',
        exam_code: '',
        bundle_firebase_collection_name: 'SERIES66',
    }
]

export const EXAM_TITLES = {
  'sie': 'SIE',
  'series6': 'Series 6',
  'series7': 'Series 7',
  'series63': 'Series 63',
  'series65': 'Series 65',
  'series66': 'Series 66'
}

export const BUNDLE_APP_NAME = "SECURITIES";

export const IS_BUNDLE_APP = true;

// Paywall headline (two lines; line2 is the accent line). Shared by web + mobile
// so both surfaces render one headline. Consumed via @learnzapp/core/pricing
// resolveHeadline, which fills a fallback if either line is blank.
export const PAYWALL_COPY = {
    headline: {
        line1: 'Everything You Need to',
        line2: 'Pass FINRA Securities Exams',
    },
};
